import { render, staticRenderFns } from "./ProductPanelItem.vue?vue&type=template&id=6c9d7f4f&scoped=true&"
import script from "./ProductPanelItem.vue?vue&type=script&lang=js&"
export * from "./ProductPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductPanelItem.vue?vue&type=style&index=0&id=6c9d7f4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d7f4f",
  null
  
)

export default component.exports